<div class="inactive-user-page">
  <p>Your account is not active. Please contact your administrator for assistance.</p>
</div>
